const root = 'BusinessInfoPage'

export const TestId = {
  root,
  title: `${root}-title`,
}
